import React from 'react';
import { total_users, active_users, inactive_users, added_users, updated_users, removed_users } from '../../assets/img';
import styles from './card-list-custom.module.scss';
import { useHistory } from 'react-router-dom';

const fetchData = [
  {
    id: 1,
    name: 'Total Users',
    key: 'total_users',
    icon: total_users,
    type: 1,
  },
  {
    id: 2,
    name: 'Active Users',
    key: 'active_users',
    icon: active_users,
    type: 1,
  },
  {
    id: 3,
    name: 'Inactive Users',
    key: 'inactive_users',
    icon: inactive_users,
    type: 1,
  },
  {
    id: 4,
    name: 'Added Users',
    key: 'added_users',
    icon: added_users,
    type: 2,
  },
  {
    id: 5,
    name: 'Updated Users',
    key: 'updated_users',
    icon: updated_users,
    type: 2,
  },
  {
    id: 6,
    name: 'Removed Users',
    key: 'removed_users',
    icon: removed_users,
    type: 2,
  },
];

const CardListCustom = ({ userStatistic }) => {
  const history = useHistory();

  const handleClickCardItem = (record) => {
    history.push(`/admin/user-access-management/list-of-user-details/${record.id}?type=${record.name}`);
  };

  const dataStatistic = fetchData.map((item) => ({
    ...item,
    value: userStatistic[item.key],
  }));

  return (
    <div className={styles.cardListCustomWrap}>
      <div className={styles.cardListItems}>
        {dataStatistic
          .filter((f) => f.type === 1)
          .map((i) => (
            <div key={i?.id} className={styles.cardListItem} onClick={() => handleClickCardItem(i)}>
              <div className={styles.cardListItemInfo}>
                <h4>{i.name}</h4>
                <div className={styles.cardListItemInfoVal}>{i.value ?? ''}</div>
              </div>
              <img className={styles.cardListItemIcon} src={i.icon} alt="" />
            </div>
          ))}
      </div>
      <div className={`${styles.cardListItems} ${styles.cardListItemsType1}`}>
        {dataStatistic
          .filter((f) => f.type === 2)
          .map((i) => (
            <div key={i?.id} className={styles.cardListItem} onClick={() => handleClickCardItem(i)}>
              <div className={styles.cardListItemInfo}>
                <h4>{i.name}</h4>
                <div className={styles.cardListItemInfoVal}>{i.value ?? ''}</div>
              </div>
              <img className={styles.cardListItemIcon} src={i.icon} alt="" />
            </div>
          ))}
      </div>
    </div>
  );
};

export default CardListCustom;
